import axios, { InternalAxiosRequestConfig, AxiosError } from "axios";
import { toast } from "react-hot-toast";
// import { toast } from "react-hot-toast";

const handleSuccess = (response: any) => {
  switch (response.status) {
    case 200:
      // Handle success logic here
      break;
    case 201:
      // Handle success logic for status code 201 here
      break;
    default:
      // Handle unknown error logic here
      break;
  }
};

const handleClientError = (response: any) => {
  switch (response.status) {
    case 400:
      toast.error(response.data.message);
      // Handle client error logic for status code 400 here
      break;
    case 401:
      toast.error(response.data.message);
      // Handle client error logic for status code 401 here
      break;
    default:
      // Handle unknown error logic here
      break;
  }
};

const getRange = (code: number) => {
  if (code >= 200 && code < 300) {
    return "SUCCESS_RANGE";
  }
  if (code >= 400 && code < 500) {
    return "CLIENT_ERROR_RANGE";
  }
  if (code >= 500 && code < 600) {
    return "SERVER_ERROR_RANGE";
  }
  return "UNKNOWN";
};

const handleResponse = (response: any) => {
  const range = getRange(response.status);
  switch (range) {
    case "SUCCESS_RANGE":
      handleSuccess(response);
      break;
    case "CLIENT_ERROR_RANGE":
      handleClientError(response);
      break;
    case "SERVER_ERROR_RANGE":
      // Handle server error logic here
      break;
    case "UNKNOWN":
      // Handle unknown error logic here
      break;
    default:
      // Handle unknown error logic here
      break;
  }
};

const axiosInstance: any = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  // Other Axios configurations...
});

// let cancelTokenSource: CancelTokenSource;

// Add request interceptor
axiosInstance.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    // Modify config or add headers before sending the request
    return config;
  },
  (error: AxiosError) => {
    // Handle request error
    return Promise.reject(error);
  },
);

// Add response interceptor
// Add response interceptor
axiosInstance.interceptors.response.use(
  (response: any) => {
    // Modify response data before resolving the promise
    return Promise.resolve(response);
  },
  (error: AxiosError) => {
    // const errorData: any = error.response?.data;
    // toast.error(errorData.message);

    handleResponse(error.response);
    return Promise.reject(error);
  },
);
export default axiosInstance;
